import React from 'react';
import { useTranslation } from '../../contexts/TranslationContext';
import '../../config';

const ResultDetailsModal = ({ isOpen, onClose, productDetails }) => {
  const { language } = useTranslation();

  if (!isOpen || !productDetails) return null;
  
  // Debug log to see what data we're receiving
  console.log("Modal product details:", productDetails);

  const getImageUrl = (imageInfo) => {
    if (!imageInfo || !imageInfo.S3RelativePath) return "";
    let s3Path = imageInfo.S3RelativePath.startsWith("/")
      ? imageInfo.S3RelativePath.substring(1)
      : imageInfo.S3RelativePath;
    let _linkImgS3 = global.config.images3.link;
    if (!_linkImgS3) return "";

    return _linkImgS3.endsWith("/")
      ? `${_linkImgS3}${s3Path}`
      : `${_linkImgS3}/${s3Path}`;
  };

  // Get score class for styling
  const getScoreClass = (score) => {
    if (score >= 25) return 'excellent';
    if (score >= 17.5) return 'good';
    if (score >= 12.5) return 'moderate';
    return 'low';
  };
  // Get score for a specific image if available
  const getImageScore = (imageId) => {
    // console.log("Image ID:", imageId, "Scores:", productDetails.imageScores);
    if (!productDetails.imageScores || !Array.isArray(productDetails.imageScores)) return null;
    
    // Find the score entry for this image ID
    const scoreEntry = productDetails.imageScores.find(s => s.ImageID === imageId);
    return scoreEntry ? scoreEntry.Score : null;
  };

  const getImagesByType = (images, typeFilter) => {
    if (!images || !Array.isArray(images)) return [];
    return images.filter(img => 
      img.Type === typeFilter
    );
  };

  const soleImages = productDetails.Images ? getImagesByType(productDetails.Images, global.config.Defines.ImageTypeKey.SHOE_SOLE_LEFT)
    .concat(getImagesByType(productDetails.Images, global.config.Defines.ImageTypeKey.SHOE_SOLE_RIGHT))
    .concat(getImagesByType(productDetails.Images, global.config.Defines.ImageTypeKey.SHOE_SOLE_UNDETERMINED)) : [];
  
  const printImages = productDetails.Images ? getImagesByType(productDetails.Images, global.config.Defines.ImageTypeKey.SHOE_PRINT_LEFT)
    .concat(getImagesByType(productDetails.Images, global.config.Defines.ImageTypeKey.SHOE_PRINT_RIGHT))
    .concat(getImagesByType(productDetails.Images, global.config.Defines.ImageTypeKey.SHOE_PRINT_UNDETERMINED)) : [];
  
  const otherImages = productDetails.Images ? getImagesByType(productDetails.Images, global.config.Defines.ImageTypeKey.SHOE_OTHER) : [];
  return (
    <div className="result-details-modal-overlay">
      <div className="result-details-modal" style={{ maxWidth: '1200px', width: '95%' }}>
        <div className="modal-header">
          <div className="header-info">
            <h2>{productDetails.Make} {productDetails.Model}</h2>
            <span className={`result-score ${getScoreClass(productDetails.score)}`}>
              {Math.round(productDetails.score)}%
            </span>
          </div>
          <button className="close-button" onClick={onClose}>
            <i className="fa fa-times"></i>
          </button>
        </div>

        <div className="modal-content">
          <div className="product-info" style={{ minWidth: '100%' }}>
            <div className="info-section" style={{ minWidth: '400px', flex: '1 1 auto' }}>
              <h3>{language?.details?.productInfo || 'Product Information'}</h3>
              <div className="info-grid">
                <div className="info-row">
                  <span className="info-label">{language?.details?.make || 'Make'}</span>
                  <span className="info-value">{productDetails.Make || 'N/A'}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">{language?.details?.model || 'Model'}</span>
                  <span className="info-value">{productDetails.Model || 'N/A'}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">{language?.details?.shoeType || 'Shoe Type'}</span>
                  <span className="info-value">{productDetails.ShoeType || 'N/A'}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">{language?.details?.productCode || 'Product Code'}</span>
                  <span className="info-value">{productDetails.ProductCode || 'N/A'}</span>
                </div>
                {productDetails.Brand && (
                  <div className="info-row">
                    <span className="info-label">{language?.details?.brand || 'Brand'}</span>
                    <span className="info-value">{productDetails.Brand}</span>
                  </div>
                )}
                {productDetails.ModelSizeRange && (
                  <div className="info-row">
                    <span className="info-label">{language?.details?.sizeRange || 'Size Range'}</span>
                    <span className="info-value">{productDetails.ModelSizeRange}</span>
                  </div>
                )}
                {productDetails.ReleaseYear && (
                  <div className="info-row">
                    <span className="info-label">{language?.details?.releaseYear || 'Release Year'}</span>
                    <span className="info-value">{productDetails.ReleaseYear}</span>
                  </div>
                )}
                <div className="info-row">
                  <span className="info-label">{language?.details?.matchScore || 'Match Score'}</span>
                  <span className={`info-value score-value ${getScoreClass(productDetails.score)}`}>
                    {Math.round(productDetails.score)}%
                  </span>
                </div>
              </div>
            </div>

            <div className="images-section">
              <h3>{language?.details?.images || 'Images'}</h3>
                {soleImages.length > 0 && (
                <div className="image-category">
                  <h4>{language?.details?.soleImages || 'Sole Images'}</h4>
                  <div className="image-grid">                    {soleImages.map((img, index) => {
                      const imageScore = getImageScore(img.IDValue);
                      return (
                        <div className="image-item" key={index}>
                          <img src={getImageUrl(img)} alt={`Sole ${index + 1}`} />
                          {imageScore !== null && imageScore > 0 && (
                            <span className={`image-score ${getScoreClass(imageScore)}`}>
                              {Math.round(imageScore)}%
                            </span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              
              {printImages.length > 0 && (
                <div className="image-category">
                  <h4>{language?.details?.printImages || 'Print Images'}</h4>
                  <div className="image-grid">                    {printImages.map((img, index) => {
                      const imageScore = getImageScore(img.IDValue);
                      return (
                        <div className="image-item" key={index}>
                          <img src={getImageUrl(img)} alt={`Print ${index + 1}`} />
                          {imageScore !== null && imageScore > 0 && (
                            <span className={`image-score ${getScoreClass(imageScore)}`}>
                              {Math.round(imageScore)}%
                            </span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              
              {otherImages.length > 0 && (
                <div className="image-category">
                  <h4>{language?.details?.otherImages || 'Other Images'}</h4>
                  <div className="image-grid">                    {otherImages.map((img, index) => {
                      const imageScore = getImageScore(img.IDValue);
                      return (
                        <div className="image-item" key={index}>
                          <img src={getImageUrl(img)} alt={`Other ${index + 1}`} />
                          {imageScore !== null && imageScore > 0 && (
                            <span className={`image-score ${getScoreClass(imageScore)}`}>
                              {Math.round(imageScore)}%
                            </span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="btn btn-primary" onClick={onClose}>
            {language?.common?.close || 'Close'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResultDetailsModal;
